<template>
    <div class="add_before_box pop-up2">
        <div class="t_tit" v-if="datalist.duplicateList.length < 200">重复采购列表({{datalist.duplicateList.length}})</div>
        <div class="t_tit" v-else >重复采购{{datalist.duplicateList.length}}种！</div>
        
        <!-- <el-form :rules="rules" ref="formName" :model="form" label-width="150px" size="mini">
            
            <el-row class="form_row2">
                <el-col :span="22" class="">
                    <el-form-item label="复本数：" class="form_inp" prop="num">
                        
                    </el-form-item>
                </el-col>
            </el-row>
           
        </el-form> -->
        <!-- <el-input-number  v-model="amount" :min="1" :max="5"></el-input-number> -->

        <el-table                
            @selection-change="selectionChangeHandler"                
        ref="multipleTable"
        v-bind:data="datalist.duplicateList" height="250"
        v-if="datalist.duplicateList.length < 200"
        >
        <el-table-column type="selection"/>
        <el-table-column label="ISBN">
            <template slot-scope="scope">
                <span class="name" @click="BookDetailClick(scope.row.goodsId)">{{ scope.row.isbn }}</span>
            </template>title
        </el-table-column>
        
        <el-table-column label="名称">
            <template slot-scope="scope">
                <span >{{ scope.row.title }}</span>
            </template>
        </el-table-column>
       </el-table>



        <div class="btn_box">
            <el-button class="btn_add_canle" @click="cancelInventtory">放弃提交</el-button>
            <el-button class="btn_add_sure" @click="submitNo">提交非重复({{datalist.notDuplicateGoods.length}})</el-button>
            <el-button v-if="datalist.notDuplicateGoods.length < 200" class="btn_add_sure" @click="submitSave">提交非重复及选中({{Number(selectRow.length)+Number(datalist.notDuplicateGoods.length)}})</el-button>
            <el-button class="btn_add_sure" @click="submitAll">提交所有({{datalist.all.length}})</el-button>
        </div>
    </div>
</template>
    
    <script>
        import {Button} from 'element-ui'

        export default {
            props: {
                datalist: {
                    type: Object,
                    default() {
                        return {
                            all:[],
                            duplicateList:[],
                            notDuplicateGoods:[],
                        };
                    }
                }
            },
            components:{
                'el-button':Button
            },
            data() {
                return {
                    selectRow:[]
                }
            },
            watch:{

            },
            created(){
                
            },
            mounted() {
                
                let vm = this;
                
            },
            methods:{
                submitSave(){//选择部分
                    let vm = this,
                    arr = this.selectRow.map(function(item){
                        return item.goodsId
                    });
                    vm.datalist.notDuplicateGoods.forEach(function(item){
                         arr.push(item.goodsId)
                    });
                    vm.$emit('submit',{goodsIdList:arr});
                },
                submitNo(){//非重复
                    let vm = this,
                    arr = vm.datalist.notDuplicateGoods.map(function(item){
                        return item.goodsId
                    });
                    vm.$emit('submit',{goodsIdList:arr});
                },
                submitAll(){//全部
                    let vm = this,
                    arr = vm.datalist.all.map(function(item){
                        return item.goodsId
                    });
                    vm.$emit('submit',{goodsIdList:arr});
                },
                selectionChangeHandler(val) {
                    this.selectRow = val;
                },
                // 点击跳转详情页
                BookDetailClick(goodsId) {
                    window.open(`#/BookDetail/${goodsId}`, "_blank");
                },
                //取消
                cancelInventtory(){
                    let vm = this;
                    vm.$emit('cancel')
                },
            }
        }
    </script>
    
    <style lang='scss'>
        .add_before_box{
            .t_tit{
                font-weight: bold;
                font-size: 16px;
            }
            .name{
                text-decoration: underline;
                cursor: pointer;
            }
            text-align: center;
            // height: 250px;
            .form_row .form_inp{
                margin-left: -70px;
            }
            .btn_box{
                margin-top:8px;
            }
        }
    </style>


// WEBPACK FOOTER //
// src/components/addCarBefore.vue